<section class="main">
    <app-checklist 
        [ngClass]="{'hide-component': !serviceOrderModel }" 
        [serviceOrder]="serviceOrderModel"
        [externAccessToken]="this.accesstoken"
    >
    </app-checklist>


</section>